import styled from '@emotion/styled';
import { Tooltip as TooltipBase } from 'react-tooltip';

export const ServiceCard = styled.div`
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dfe0e0;
  padding: 24px;
  margin-top: 20px;
`;

export const InfoContainer = styled.div`
  display: flex;
  gap: 16px;
  position: relative;

  .checkbox {
    label {
      padding: 0 !important;

      input {
        position: relative;
        top: 0;
        left: 0;
        margin-right: 12px;
        margin-left: 12px;
      }
    }
  }
`;

export const InfoContainerData = styled.div`
  width: 100%;

  & > * {
    margin-bottom: 8px;
  }
`;

export const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  padding-bottom: 20px;
  font-size: 18px;
  color: black;
  font-weight: 700;

  * {
    margin: 0;
  }
`;

export const ComponentsContainer = styled.div`
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const Component = styled.div`
  border-radius: 8px;
  padding: 16px;
  background: rgba(231, 240, 247, 0.5);

  & > div {
    &:not(:first-of-type) {
      margin-top: 8px;
    }
  }
`;

export const ItemRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-size: 16px;

  * {
    margin: 0;
  }
`;

export const ItemRowLabel = styled.p`
  color: #54565a;
`;

export const ItemRowValue = styled.span`
  text-align: right;
  color: black;

  &.title-value {
    font-weight: 700;
  }
`;

export const Tooltip = styled(TooltipBase)`
    width: 100%;
    max-width: 233px;
    border-radius: 8px;
    background: #000;
    font-size: 12px;
    opacity: 1;
  `
